import '@aerisweather/javascript-sdk/dist/styles/styles.css'
import React from 'react'
import { LayersControl, TileLayer } from 'react-leaflet'
import 'leaflet-geosearch/dist/geosearch.css'

import 'react-leaflet-fullscreen/dist/styles.css'
import { FullscreenControl } from 'react-leaflet-fullscreen'
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import { MapContainer } from './MapContainer'
import { BaseLayer, MapViewProps } from './types'

const MapView = React.forwardRef(
  (
    {
      children,
      mapKey,
      defaultBaseLayer = BaseLayer.OSMMAPNIK,
      aerisLayer,
      leafletMapConfig,
      fullScreenControlPosition = 'bottomleft',
      ZoomControlPosition = 'bottomright',
      layersControlPosition = 'topright',
      className,
      style,
      region = 'IN'
    }: MapViewProps,
    ref?: any
  ) => {
    if (!ref) {
      ref = React.createRef()
    }
    return (
      <MapContainer
        zoom={13}
        scrollWheelZoom={true}
        id="fareye-leaflet"
        style={{ width: '100%', height: '100%' }}
        {...leafletMapConfig}
        aerisLayer={aerisLayer}
        className={className}
      >
        <FullscreenControl position={fullScreenControlPosition} />
        <LayersControl position={layersControlPosition}>
          <LayersControl.BaseLayer
            checked={defaultBaseLayer === BaseLayer.OSMMAPNIK}
            name={BaseLayer.OSMMAPNIK}
          >
            <TileLayer
              attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer
            checked={defaultBaseLayer === BaseLayer.GMROADS}
            name={BaseLayer.GMROADS}
          >
            <ReactLeafletGoogleLayer
              apiKey={mapKey}
              googleMapsLoaderConf={{ region: region, apiKey: mapKey }}
              // @ts-ignore
              type='roadmap'
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer
            checked={defaultBaseLayer === BaseLayer.GMTERRAIN}
            name={BaseLayer.GMTERRAIN}
          >
            <ReactLeafletGoogleLayer
              apiKey={mapKey}
              googleMapsLoaderConf={{ region: region, apiKey: mapKey }}
              // @ts-ignore
              type='terrain'
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer
            checked={defaultBaseLayer === BaseLayer.GMSATELLITE}
            name={BaseLayer.GMSATELLITE}
          >
            <ReactLeafletGoogleLayer
              apiKey={mapKey}
              googleMapsLoaderConf={{ region: region, apiKey: mapKey }}
              // @ts-ignore
              type='satellite'
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer
            checked={defaultBaseLayer === BaseLayer.GMHYBRID}
            name={BaseLayer.GMHYBRID}
          >
            <ReactLeafletGoogleLayer
              apiKey={mapKey}
              googleMapsLoaderConf={{ region: region, apiKey: mapKey }}
              // @ts-ignore
              type='hybrid'
            />
          </LayersControl.BaseLayer>
        </LayersControl>
        {children}
      </MapContainer>
    )
  }
)

export default MapView
